import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import { Box, FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, Switch, TextField } from '@mui/material'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import PersonIcon from '@mui/icons-material/Person'
import "./css/AddLead.css"
import DiamondIcon from '@mui/icons-material/Diamond'
import FormatColorTextIcon from '@mui/icons-material/FormatColorText'
import SourceIcon from '@mui/icons-material/Source'
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks'
import AddIcon from '@mui/icons-material/Add'
import YouTubeIcon from '@mui/icons-material/YouTube'
import ImportContactsIcon from '@mui/icons-material/ImportContacts'
import { PiPlus } from 'react-icons/pi'
import api from '../config/backend'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'






// 
const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}))

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}))

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}))

const UpdateLead = ({ isPopup, setPopup, setTriggerRefresh, leadData }) => {

    // const [childopen, setChildOpen] = React.useState(false);

    // const handlechiledClickOpen = () => {
    //     setChildOpen(true);
    // };
    // const handlechiledClose = () => {
    //     setChildOpen(false);
    // };

    // axios 

    const [stagesData, setStagesData] = useState([])
    const [clientname, setClientname] = useState(leadData.clientname || '')
    const [clientemail, setClientemail] = useState(leadData.clientemail || '')
    const [profileimage, setProfileimagel] = useState(leadData.profileimage || '')
    const [clientphone, setClientphone] = useState(leadData.clientphone || '')
    const [company, SetCompany] = useState(leadData.company || '')
    const [designation, setDesignation] = useState(leadData.designation || '')
    const [website, setWebsite] = useState(leadData.website || '')
    const [stage, setStage] = useState(leadData.stage || '')
    const [privacy, setprivacy] = useState(leadData.privacy || '')
    const [dealsize, setDealsize] = useState(leadData.dealsize || '')
    const [tags, setTags] = useState(leadData.tags || '')
    const [address, setAddress] = useState(leadData.address || '')
    const [city, setCity] = useState(leadData.city || '')
    const [state, setState] = useState(leadData.state || '')
    const [country, setCountry] = useState(leadData.country || '')
    const [zipcode, setZipcode] = useState(leadData.zipcode || '')
    const [note, setNote] = useState(leadData.note || '')

    const [nameError, setNameError] = useState(false)
    // const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(false)
    const [invalidWebsite, setInvalidWebsite] = useState(false)

    const validateEmailFormat = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return emailRegex.test(clientemail)
    }

    const handleEmailChange = (e) => {
        setClientemail(e.target.value)
        if (emailError) {
            setEmailError(false)
        }
    }
    const handleEmailBlur = () => {
        if (clientemail.trim() !== '') {
            const isValidEmail = validateEmailFormat()
            setEmailError(!isValidEmail)
        }
    }
    const token = localStorage.getItem("_crm__token")

    const fetchStages = async () => {
        const { data, status } = await axios.post(`${api}/Stages/fetch-stages`, { token })

        if (data.success) {
            setStagesData(data.stages)
            console.log(data.stages)
        } else {
            console.log(data.message)
        }
    }

    useEffect(() => {
        fetchStages()
    }, [])


    console.log(stagesData)

    console.log(leadData)
    // const updateformSubmissions = async () => {

    //     const { data, status } = await axios.post(`${api}/Leads/update-lead`, {
    //         hash,
    //         token,
    //         clientname,
    //         clientemail,
    //         clientphone,
    //         company,
    //         designation,
    //         website,
    //         stage,
    //         dealsize,
    //         address,
    //         city,
    //         state,
    //         country,
    //         zipcode,
    //     })

    //     if (data.success) {
    //         setSubmitData(data.success)
    //         setPopup(false)
    //     } else {
    //         console.log({ data })

    //     }
    // }

    // const handleDelete = async () => {
    //     const { data, status } = await axios.post(`${api}/Leads/delete-lead`, { token, hash })
    // }



    // accodian
    const handleClose = () => {
        setPopup(false)
    }

    const [expanded, setExpanded] = useState('panel1')

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false)
    }

    // toggle switch
    const label = { inputProps: { 'aria-label': 'Switch demo' } }

    // // date picker
    // const [value, setValue] = useState(null);
    const handleSaveChanges = async () => {
        if (emailError) {
            return
        }

        if (website && website.match(/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/) === null) {
            setInvalidWebsite(true)
            return
        }

        if (clientname.match(/(^[A-Z][a-z]{3}|\w{4})(?:\s\w+)?(\w+)$/) === null) {
            setNameError(true)
            return
        }

        try {
            const response = await axios.post(`${api}/Leads/update-lead`, {

                token,
                hash: leadData.hash,
                clientname, profileimage, clientemail, clientphone, company, designation, website, stage, privacy, dealsize, address, city, state, country, zipcode,
            })

            if (response.data.success) {

                toast.success('Lead updated successfully')
                setPopup(false)

                setTriggerRefresh(prev => prev + 1)
            } else {

                toast.error(response.data.message)
            }
        } catch (error) {

            console.error(error)
            toast.error('Error: failed to update lead')
        }
    }
    return (
        <div>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={isPopup}
                className='app-dialog-addlead'
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Update Lead
                </DialogTitle>

                <IconButton
                    aria-label="close"
                    onClick={() => setPopup(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                            <Typography className="_1st_span" variant='span'><PersonIcon />Lead info</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box>
                                <Grid container columnSpacing={2} rowSpacing={3}>
                                    <Grid item md={6} lg={6}>
                                        <div class="app-form-field">
                                            <TextField
                                                required
                                                name='clintname'
                                                value={clientname}
                                                onChange={(e) => {
                                                    setNameError(false)
                                                    setClientname(e.target.value)
                                                }}
                                                id="outlined-required"
                                                label="Name"
                                                error={nameError}
                                                helperText={nameError ? "Please enter a valid name" : ""}
                                            />
                                            {/* {nameError && (
                                                <Typography variant="caption" color="error">
                                                    Name is required
                                                </Typography>
                                            )} */}
                                        </div>
                                    </Grid>
                                    <Grid item md={6} lg={6}>
                                        <div class="app-form-field">
                                            <TextField
                                                label="Email"
                                                name='email'
                                                value={clientemail}
                                                onBlur={handleEmailBlur}
                                                onChange={handleEmailChange}
                                                id="outlined-required"
                                                error={emailError}
                                                helperText={emailError ? 'Invalid email format' : ''}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item md={6} lg={6}>
                                        <div class="app-form-field">
                                            <TextField
                                                value={clientphone}
                                                onChange={(e) => {
                                                    if (e.target.value === "" || e.target.value.match(/^\d+$/)) {
                                                        setClientphone(e.target.value)
                                                    }
                                                }}
                                                id="outlined-required"
                                                label="Phone Number"
                                                name='mobile'
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item md={6} lg={6}>
                                        <div class="app-form-field">
                                            <TextField
                                                name='company'
                                                id="outlined-required"
                                                label="Company"
                                                value={company}
                                                onChange={(e) => SetCompany(e.target.value)}

                                            />
                                        </div>
                                    </Grid>
                                    <Grid item md={6} lg={6}>
                                        <div class="app-form-field">
                                            <TextField
                                                name='designation'
                                                id="outlined-required"
                                                label="Designation"
                                                value={designation}
                                                onChange={(e) => setDesignation(e.target.value)}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item md={6} lg={6}>
                                        <div class="app-form-field">
                                            <TextField
                                                name='website'
                                                id="outlined-required"
                                                label="Website"
                                                value={website}
                                                onChange={(e) => {
                                                    setInvalidWebsite(false)
                                                    setWebsite(e.target.value)
                                                }}
                                                error={invalidWebsite}
                                                helperText={invalidWebsite ? 'Invalid website link' : ''}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item md={6} lg={6}>
                                        <div class="app-form-field">
                                            <TextField
                                                name='dealsize'
                                                id="outlined-required"
                                                label="Deal Size"
                                                value={dealsize}
                                                onChange={(e) => {
                                                    if (e.target.value === "" || e.target.value.match(/^\d+$/)) {
                                                        setDealsize(e.target.value)
                                                    }
                                                }}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">₹</InputAdornment>
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item md={6} lg={6}>
                                        <div class="app-form-field">
                                            <FormControl sx={{ m: 1, width: "27ch" }}>
                                                <InputLabel>Stage</InputLabel>
                                                <Select
                                                    label="Stage"
                                                    value={stage}
                                                    onChange={(e) => setStage(e.target.value)}
                                                >
                                                    {stagesData.map((item, index) => {
                                                        console.log({ item })
                                                        return (
                                                            <MenuItem key={index} value={item.name}>{item.name}</MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Box>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                            <Typography className="_1st_span" variant='span'><SourceIcon />Billing details</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box>
                                <Grid container>
                                    <Grid item md={6} lg={6}>
                                        <div class="app-form-field">
                                            <TextField
                                                name='address'
                                                id="outlined-required"
                                                label="Address"
                                                value={address}
                                                onChange={(e) => setAddress(e.target.value)}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item md={6} lg={6}>
                                        <div class="app-form-field">
                                            <TextField
                                                name='city'
                                                id="outlined-required"
                                                label="City"
                                                value={city}
                                                onChange={(e) => setCity(e.target.value)}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item md={6} lg={6}>
                                        <div class="app-form-field">
                                            <TextField
                                                name='state'
                                                id="outlined-required"
                                                label="State"
                                                value={state}
                                                onChange={(e) => setState(e.target.value)}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item md={6} lg={6}>
                                        <div class="app-form-field">
                                            <TextField
                                                name='country'
                                                id="outlined-required"
                                                label="Country"
                                                value={country}
                                                onChange={(e) => setCountry(e.target.value)}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item md={6} lg={6}>
                                        <div class="app-form-field">
                                            <TextField
                                                name='zipcode'
                                                id="outlined-required"
                                                label="PinCode"
                                                value={zipcode}
                                                onChange={(e) => setZipcode(e.target.value)}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </Box>
                        </AccordionDetails>
                    </Accordion>

                </DialogContent>
                <DialogActions>
                    <Button variant="contained" className='app-btn-contained app-btn-primary' onClick={handleSaveChanges} autoFocus>
                        Save changes
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    )
}

export default UpdateLead